import { css } from '@emotion/core';
import { WeaveTheme } from 'dsm/theme';

export type TextSize = 'large' | 'medium' | 'small' | 'inherit';

export const getFontSizeStyle = (size: TextSize, theme: WeaveTheme) => {
  return css`
    font-size: ${theme.font.size[size] ?? size};
    line-height: ${theme.font.lineHeight};
  `;
};

export type TextAlignment = 'left' | 'center' | 'right' | 'inherit';

export const getTextAlignStyle = (align: TextAlignment) => css`
  text-align: ${align};
`;

export const getFontFamilyStyle = (theme: WeaveTheme) =>
  css`
    font-family: ${theme.font.family};
  `;

export type FontWeight = 'regular' | 'bold' | 'inherit' | 'light' | 'medium' | 'semibold';

export const getFontWeightStyle = (weight: FontWeight, theme: WeaveTheme) => css`
  font-weight: ${theme.font.weight[weight]};
`;
